/*
    METHODS:

    # ComponentModule.AddModule(target, options)
        * Arguments:
            - {string} target
            - {Object} options
        * Usage:
           Register a Module. Registration allows starting a new Vue instance with the configuration that you provide in 'options' object. 'target' argument is used to find the elements in the DOM and provides the Vue instance an existing DOM element to mount on. It can be a CSS selector string.

    # ComponentModule.Init:
        The function that initializes every Module added.

    OBJECTS:

    # Options
        With the 'options' argument can pass the configuration options for Vue (https://vuejs.org/v2/api/#Options-Data) except 'el' and 'components' options, and additionally the next options:

        - {array[object]} components:
          this works like Local Registration Component in Veu (https://vuejs.org/v2/guide/components-registration.html), just is an array in place of an object and the id component must be in the 'name' parameter. i.e:

          [Directly in VUE]:

              new Vue({
                el: '#app',
                components: {
                    'component-a': ComponentA,
                    'component-b': ComponentB
                }
              });

          [HERE]:

              ...
              components: [ { name: 'component-a', ...ComponentA }, { name: 'component-b', ...ComponentB } ],
              ...

        - {string} prefix:
            this will be added to every id component as prefix, i.e:
            prefix = "comp_" and component.name = "form". So the final result will be 'comp_form' as id component.

        - {string} initFunc:
            this is just a simple function that is called before to create the Vue instance, for the preconditions

        - {boolean} mount:
            this value is true by default. If the value is true, will force the hydration of the module.

*/

import Vue from 'vue/dist/vue.min.js';
import store from './store';

const ComponentModule = {
    AddModule: (target, options) => {
        ComponentModule._modules.push({target, ...options});
    },

    Init: () => {
        ComponentModule._modules.forEach(({ prefix, components, initFunc, target, template, mount = true, ...vueOptions }) => {
            const _prfx = prefix || '';
            const found = document.querySelectorAll(target);
            found.forEach(el => {
                initFunc && initFunc(Vue);
                const instance = new Vue({
                    el: !template && el,
                    store: store,
                    components: components?.reduce((obj, {name, ...options}) => {
                        obj[_prfx+name] = options;
                        return obj;
                    }, {}),
                    template,
                    ...vueOptions,
                })

                mount && instance.$mount(el, true);
            });
        });
    },
};

ComponentModule._modules = [];

export default ComponentModule;
